export default __webpack_public_path__ + "static/media/mapaBR.60eebb8b.jpeg";